import { createFileRoute } from '@tanstack/react-router';
import { findNavItem } from '@/shared/patterns/AppShell';
import { platformNav } from '@/domains/platform';
import { UnderConstruction } from '@/shared/components/UnderConstruction';

// Catch-all temporal: cada item del sidebar cae aquí hasta que su pantalla real lo reemplace.
export const Route = createFileRoute('/_backoffice/superadmin/$section')({
    component: SuperadminSection,
});

function SuperadminSection() {
    const { section } = Route.useParams();
    return <UnderConstruction title={findNavItem(platformNav, section)?.label ?? section} />;
}
